import { createSelector } from 'reselect'
import { SlideDeck, SlidesStatus } from '../../../lib/slides/types'

const getSlideDecks = state => state.slides.slideDecks || []
const getActiveDeckId = state => state.slides.activeDeck

const emptySlideDeck: SlideDeck = {
  status: SlidesStatus.COMPLETE,
  timeStamp: '111',
  slidesId: 'mock-empty',
  percentageComplete: 100,
  brightTalkDataLocation: '',
  brightTalkLocation: '',
  dataLocation: '',
  s3Location: '',
  fileName: '',
  numberOfSlides: 0
}

const selectSlideDeck = createSelector(
  getSlideDecks,
  getActiveDeckId,
  (decks, id: string): SlideDeck => id ? decks.find(deck => deck.slidesId === id) : emptySlideDeck
)

export default selectSlideDeck
